import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Hourglass, LogOut, RefreshCw } from "lucide-react";

export default function PendingApproval() {
  const { user, logout } = useAuth();
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6" data-testid="pending-approval">
      <div className="w-full max-w-md rounded-2xl border border-border bg-card p-8 text-center shadow-xl">
        <img src="/logo.png" alt="FIT HOUSE" className="mx-auto mb-4 h-20 w-20 object-contain" />
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-primary/15">
          <Hourglass className="h-7 w-7 animate-pulse text-primary" />
        </div>
        <h1 className="font-heading text-2xl font-extrabold">Hesabınız onay bekliyor</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Merhaba <b>{user?.name}</b>. Kaydınız alındı; uygulamayı kullanabilmeniz için bir yöneticinin hesabınızı onaylaması gerekiyor.
          Onaylandığında bu sayfayı yenileyerek devam edebilirsiniz.
        </p>
        <p className="mt-1 text-xs text-muted-foreground" data-testid="pending-email">{user?.email}</p>
        <div className="mt-6 flex justify-center gap-2">
          <Button variant="secondary" onClick={() => window.location.reload()} data-testid="pending-refresh"><RefreshCw className="mr-1.5 h-4 w-4" /> Yenile</Button>
          <Button variant="ghost" onClick={logout} data-testid="pending-logout"><LogOut className="mr-1.5 h-4 w-4" /> Çıkış Yap</Button>
        </div>
      </div>
    </div>
  );
}
